import { Action } from 'redux';
import { Map } from 'immutable';

import {
    GET_SERVICES_REQUEST,
    GET_SERVICES_RESPONSE,
    GET_SERVICES_ERROR
} from '../../actions/Services/services';

import { Service } from '../../models/Services/Service';

export interface ServicesState {
    services: Map<string, Service>;
    loading: boolean;
    error: any;
}

const initialState: ServicesState = {
    services: Map<string, Service>(),
    loading: false,
    error: null,
};

export function servicesState(state: ServicesState = initialState, action: Action) {
    switch (action.type) {
        case GET_SERVICES_REQUEST: {
            return {
                ...initialState,
                loading: true,
            };
        }
        case GET_SERVICES_RESPONSE: {
            const result: Service[] = (action as any).response.result;
            const services = result.reduce((prev, cur) => prev.set(cur.key, cur), initialState.services);
            return {
                ...state,
                loading: false,
                services,
            };
        }
        case GET_SERVICES_ERROR: {
            const error = (action as any).error;
            return {
                ...state,
                loading: false,
                error,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Services/services.ts